/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ConfirmBulkUpdatequest,
  ConfirmBulkUpdatesponse,
} from "../types/ConfirmBulkUpdate.ts"

export const confirmBulkUpdatey = () =>
  [{ url: "/v1/product/confirm-bulk-update" }] as const

export type ConfirmBulkUpdatey = ReturnType<typeof confirmBulkUpdatey>

/**
 * @description Confirms and persists the validated updates using the validationId from the validate endpoint.
 * @summary Confirm bulk product updates (Step 2)
 * {@link /v1/product/confirm-bulk-update}
 */
export async function confirmBulkUpdate(
  data: ConfirmBulkUpdatequest,
  config: Partial<RequestConfig<ConfirmBulkUpdatequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ConfirmBulkUpdatesponse,
    ResponseErrorConfig<Error>,
    ConfirmBulkUpdatequest
  >({
    method: "POST",
    url: `/v1/product/confirm-bulk-update`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function confirmBulkUpdatetions(
  config: Partial<RequestConfig<ConfirmBulkUpdatequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = confirmBulkUpdatey()
  return mutationOptions<
    ResponseConfig<ConfirmBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmBulkUpdatequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return confirmBulkUpdate(data, config)
    },
  })
}

/**
 * @description Confirms and persists the validated updates using the validationId from the validate endpoint.
 * @summary Confirm bulk product updates (Step 2)
 * {@link /v1/product/confirm-bulk-update}
 */
export function useConfirmBulkUpdate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ConfirmBulkUpdatesponse>,
      ResponseErrorConfig<Error>,
      { data: ConfirmBulkUpdatequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ConfirmBulkUpdatequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? confirmBulkUpdatey()

  const baseOptions = confirmBulkUpdatetions(config) as UseMutationOptions<
    ResponseConfig<ConfirmBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmBulkUpdatequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ConfirmBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmBulkUpdatequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ConfirmBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmBulkUpdatequest },
    TContext
  >
}
